import type { Palette } from "./types"

import { useSettings } from "../modules/settings"
import { BALL_SIZE, DEFAULT_SIZING } from "./geometry"
import "../modules/shape-variants.css"

interface BallProps {
  ballSize?: number
  color: string
  palette: Palette
}

const BALL_CLASS_MAP = {
  circle: "sv-shape--circle",
  "circle-square": "sv-shape--circle-square",
  diamond: "sv-shape--diamond",
  donut: "sv-shape--donut",
  hexagon: "sv-shape--hexagon",
  square: "sv-shape--square",
  "square-circle": "sv-shape--square-circle",
  "square-donut": "sv-shape--square-donut",
  star: "sv-shape--star",
  star12: "sv-shape--star12",
  triangle: "sv-shape--triangle",
}

// The game balls come from two shipped sizings (122px default, 102px compact);
// .sv-shape derives its box from --sv-ball, so a size class is all a ball needs.
const SIZE_CLASS: Readonly<Record<number, string>> = {
  102: "sv-size--compact",
  [DEFAULT_SIZING.ballSize]: "sv-size--base",
}

export function Ball({ ballSize = BALL_SIZE, color, palette }: BallProps) {
  const { appSettings } = useSettings()
  const sortaballsVariant = appSettings.sortaballs?.variant
  const sortaballsStyle = appSettings.sortaballs?.style
  const entry = palette[color]
  const variantClass = BALL_CLASS_MAP[sortaballsVariant] ?? "sv-shape--circle"
  const effectClass = `sv-effect--${sortaballsStyle}`
  const checkerClass = entry?.type === "checker" ? " sv-shape--checker" : ""
  const colorClass = entry?.className ?? ""
  const sizeClass = SIZE_CLASS[ballSize] ?? "sv-size--base"
  const outerClass = `sv-shape ${variantClass} ${effectClass}${checkerClass} ${colorClass} ${sizeClass}`
  // The e2e board reader (readGameState) identifies balls by their color via
  // this aria-label, so it must survive any restructuring of the span.
  return <span aria-label={`Ball ${color}`} className={outerClass} />
}

export { BALL_SIZE }
